import { useLazyQuery } from '@apollo/client'
import React, { useEffect } from 'react'
import { Loading } from '../components'
import Layout from '../components/layout'
import { navigate } from 'gatsby'
import { MARKETPLACE_ROUTE, LOGIN_ROUTE } from '../providers/routes'
import { IS_LOGGED_IN } from '../graphql/queries/user'

const Index = () => {
  const [checkLoggedIn, { data }] = useLazyQuery(IS_LOGGED_IN)

  const isBrowser = () => typeof window !== 'undefined'

  const pushMoneyUser =
    isBrowser() && window.localStorage.getItem('pushMoneyUser')
      ? JSON.parse(window.localStorage.getItem('pushMoneyUser'))
      : null

  useEffect(() => {
    checkLoggedIn()
    if (pushMoneyUser?.token) {
      if (data?.isLoggedIn) {
        navigate(MARKETPLACE_ROUTE)
      }
    } else {
      navigate(LOGIN_ROUTE)
    }
  }, [data])

  return (
    <Layout>
      <Loading />
    </Layout>
  )
}

export default Index
